module.exports = __webpack_public_path__ + "fonts/Marianne-Bold.b7d17a6.woff2";